<template>
  <main role="main">
    <!-- Pricing & Plans -->
    <section id="section-plans">
      <b-container class="py-5">
        <div class="pricing-header mb-5 mx-auto text-center">
          <h2>Chọn gói cước phù hợp với nhu cầu của bạn</h2>
          <p class="lead">Thay đổi hoặc huỷ gói bất cứ lúc nào</p>
        </div>
        <div class="card-deck text-center">
          <div class="card mb-4 shadow-sm">
            <div class="card-header">
              <h4 class="my-0 font-weight-normal">Cơ bản</h4>
            </div>
            <div class="card-body">
              <h4 class="card-title pricing-card-title text-secondary">Miễn phí</h4>
              <b-button class="mb-3" variant="outline-secondary" size="lg" block>Chọn</b-button>
              <div class="text-left ml-4">
                <p class="text-secondary">&nbsp;</p>
                <ul class="list-unstyled mb-4">
                  <li>Tối đa 7 người / phòng họp</li>
                  <li>Tối đa 40 phút / cuộc họp</li>
                  <li>5 GB lưu trữ</li>
                  <li>10 cuộc họp / ngày</li>
                  <li>Hỗ trợ trực tuyến</li>
                </ul>
                <ul class="list-unstyled mb-4">
                  <li>Video, âm thanh chất lượng HD</li>
                  <li>Khử nhiễu, tiếng ồn</li>
                  <li>Chia sẻ màn hình, tài liệu</li>
                  <li>Ghi âm, ghi hình cuộc họp</li>
                </ul>
                <ul class="list-unstyled mb-4">
                  <li>Phòng chờ họp</li>
                  <li>Chat nhóm</li>
                  <li>Bảng trắng, bút vẽ (annotation)</li>
                  <li>Điều khiển từ xa</li>
                </ul>
                <ul class="list-unstyled mb-4">
                  <li>Mã hoá trên đường truyền (SSL)</li>
                  <li>Mã hoá AES 256 bit</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="card mb-4 shadow-sm">
            <div class="card-header">
              <h4 class="my-0 font-weight-normal">Tiêu chuẩn</h4>
            </div>
            <div class="card-body">
              <h4 class="card-title pricing-card-title">400.000 VND <small class="text-secondary">/ tháng</small></h4>
              <b-button class="mb-3" variant="outline-primary" size="lg" block :to="getPurchaseRouter()">Mua ngay</b-button>
              <div class="text-left ml-4">
                <p class="text-secondary">Bao gồm các tính năng miễn phí</p>
                <ul class="list-unstyled mb-4">
                  <li>Tối đa 30 người / phòng họp</li>
                  <li>Tối đa 4 giờ / cuộc họp</li>
                  <li>100 GB lưu trữ</li>
                  <li>50 cuộc họp / ngày</li>
                  <li>Hỗ trợ ưu tiên</li>
                </ul>
                <ul class="list-unstyled mb-4">
                  <li>Video, âm thanh chất lượng HD</li>
                  <li>Khử nhiễu, tiếng ồn</li>
                  <li>Chia sẻ màn hình, tài liệu</li>
                  <li>Ghi âm, ghi hình cuộc họp</li>
                </ul>
                <ul class="list-unstyled mb-4">
                  <li>Phòng chờ họp</li>
                  <li>Chat nhóm</li>
                  <li>Bảng trắng, bút vẽ (annotation)</li>
                  <li>Điều khiển từ xa</li>
                </ul>
                <ul class="list-unstyled mb-4">
                  <li>Mã hoá trên đường truyền (SSL)</li>
                  <li>Mã hoá AES 256 bit</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="card mb-4 shadow-sm">
            <div class="card-header">
              <h4 class="my-0 font-weight-normal">Nâng cao</h4>
            </div>
            <div class="card-body">
              <h4 class="card-title pricing-card-title">800.000 VND <small class="text-secondary">/ tháng</small></h4>
              <b-button class="mb-3" variant="outline-success" size="lg" block :to="getPurchaseRouter()">Mua ngay</b-button>
              <div class="text-left ml-4">
                <p class="text-secondary">Bao gồm các tính năng gói tiêu chuẩn</p>
                <ul class="list-unstyled mb-4">
                  <li>Tối đa 80 người / phòng họp</li>
                  <li>Tối đa 24 giờ / cuộc họp</li>
                  <li>300 GB lưu trữ</li>
                  <li>100 cuộc họp / ngày</li>
                  <li>Hotline hỗ trợ riêng</li>
                </ul>
                <ul class="list-unstyled mb-4">
                  <li>Video, âm thanh chất lượng HD</li>
                  <li>Khử nhiễu, tiếng ồn</li>
                  <li>Chia sẻ màn hình, tài liệu</li>
                  <li>Ghi âm, ghi hình cuộc họp</li>
                </ul>
                <ul class="list-unstyled mb-4">
                  <li>Phòng chờ họp</li>
                  <li>Chat nhóm</li>
                  <li>Bảng trắng, bút vẽ (annotation)</li>
                  <li>Điều khiển từ xa</li>
                </ul>
                <ul class="list-unstyled mb-4">
                  <li>Mã hoá trên đường truyền (SSL)</li>
                  <li>Mã hoá AES 256 bit</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <ul class="text-secondary">
          <li>Some explanation 2</li>
          <li>Giá hiển thị đã bao gồm VAT</li>
        </ul>
      </b-container>
    </section>

    <!-- FAQ -->
    <section>
      <b-container class="py-5">
        <div class="text-center mb-5">
          <h1>Câu hỏi thường gặp</h1>
        </div>
        <b-row>
          <b-col lg="6">
            <div class="faq-item">
              <h4>What is a Host and what is a Participant?</h4>
              <p class="text-secondary">A Participant is an invitee in a meeting scheduled by someone with a Host
                license. A Participant does not require a Zoom account in order to join a meeting. Participants can join
                a meeting from their phone, desktop, mobile and tablet devices.</p>
            </div>
            <div class="faq-item">
              <h4>How many participants can join the meeting? How many people can use one host license?</h4>
              <p class="text-secondary">All plans allow up to 100 participants by default in every meeting (up to 500 with Large Meeting add-on). You can host an unlimited number of meetings but if you would like to have more than one meeting concurrently, you will need additional host licenses.</p>
            </div>
            <div class="faq-item">
              <h4>Where can I find a Zoom W-9 for my business?</h4>
              <p class="text-secondary">If your business requires service providers to have a W-9 form on file for tax records, you can find a copy of Zoom's W-9 here.</p>
            </div>
            <div class="faq-item">
              <h4>Do you charge sales or consumption taxes?</h4>
              <p class="text-secondary">Certain US states and international countries are subject to a required sales or consumption tax. If your online order includes sales tax, VAT, GST, or comparable consumption taxes, you will see the tax amount applied in your shopping cart after the billing step and before checkout is complete.</p>
            </div>
          </b-col>
          <b-col lg="6">
            <div class="faq-item">
              <h4>What is the difference between the Basic and Pro plans?</h4>
              <p class="text-secondary">Zoom offers a full-featured Basic Plan for free with unlimited meetings. Try Zoom for as long as you like - there is no trial period. Your Basic plan has a 40 minutes time limit on meetings with three or more total participants. Need your group meetings to last longer than 40 minutes? Sign up for a Pro Account here.</p>
            </div>
            <div class="faq-item">
              <h4>What payment methods do you accept?</h4>
              <p class="text-secondary">Zoom accepts credit card and Paypal payments online. To pay by check, wire transfer or ACH, please call 1.888.799.9666.</p>
            </div>
            <div class="faq-item">
              <h4>How does the subscription service work? Can I cancel my subscription?</h4>
              <p class="text-secondary">Zoom is a subscription-based service, which means that your plan renews every month or year (depending on the term you choose). You can cancel your subscription at any time during your plan term to cancel the auto-renewal of your subscription.</p>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>

  </main>
</template>

<style lang="scss" scoped>
  #section-plans {
    background-color: #f8f9fa;
  }

  .card-deck .card {
    min-width: 220px;
  }

  .card-body ul {
    line-height: 175%;
  }

  .faq-item {
    margin-bottom: 2.5rem;
  }
</style>

<script lang="ts">
  import {Component, Vue} from 'vue-property-decorator';
  import _ from "lodash";

  import * as userService from "@/service/userService";
  import BaseComponent from "@/components/BaseComponent";

  @Component
  export default class PricingPlans extends BaseComponent {

    mounted() {

    }

    getPurchaseRouter(): string {
      return userService.isSignedIn()? "/place-order/payment" : "/place-order/create-account";
    }

  }
</script>
